import { render, staticRenderFns } from "./StudentNavbar.vue?vue&type=template&id=55ce94c2&"
import script from "./StudentNavbar.vue?vue&type=script&lang=js&"
export * from "./StudentNavbar.vue?vue&type=script&lang=js&"
import style0 from "./StudentNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports